export const SettingType = ({ type, className, setType = () => { } }) => {
    return (
        <select name="setting" id="settings" className={className} onChange={setType}>
            <option defaultValue={''} value="material">Sélectionnez une option</option>
            {type.map((element, index) => (
                <option key={index} value={element.name}>{element.name}</option>
            ))}
        </select>
    )
}